<template>
  <div>
    <b-input-group>
      <input
        v-for="(filter, index) in filters"
        :key="index"
        type="text"
        :name="`search${filter.field}`"
        class="form-control"
        v-model="search_fields[index]"
        :class="index ? 'ml-2' : ''"
        :placeholder="'Search by ' + filter.label"
      />
    </b-input-group>
  </div>
</template>

<script>
import { useSearch } from "../../stores/search";
export default {
  props: ['filters'],
  created() {
    const searchKeys = this.filters.map(filter => filter.field);
    this.useSearch.setSimpleSearchKeys(searchKeys);
  },
  computed: {
    search_fields() {
      return this.useSearch.getSimpleSearch;
    },
    simpleSearchKeys() {
      let result = this.useSearch.simpleSearchKeys;console.log(result)

      return result.map((key) => {
        if (key === "id") {
          return key.toUpperCase();
        } else {
          return key;
        }
      });
    },
  },
  data() {
    return {
      useSearch: useSearch()
    }
  },
};
</script>
